<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 13L11 7.71154L5 2"
      :stroke="primary ? '#174DD9' : color"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'IconArrowRight',
  props: {
    color: {
      type: String,
      default: '#999BA3',
    },
    primary: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
